import React from 'react';
import Type from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { Typography } from "@mui/material";
import { createFilterOptions } from '@mui/material/Autocomplete';
import { SimpleAutocomplete } from 'components';
import { useTranslation } from 'hooks';

const filter = createFilterOptions();

const ContactPersonField = (props) => {
  const { loading, options: optionsProp } = props;
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext();

  const handleChange = (event, newValue) => {
    if (newValue && newValue.inputValue) {
      setFieldValue('name', { name: newValue.inputValue });
    } else {
      setFieldValue('name', newValue);
      setFieldValue('phone', newValue ? newValue.phone : '');
    }
  };

  return (
    <Field
      sx={{mt: 2}}
      id="name"
      name="name"
      component={SimpleAutocomplete}
      getOptionLabel={(option) => {
        if (option.inputValue) {
          return option.inputValue;
        }

        return option.name;
      }}
      options={optionsProp}
      loading={loading}
      renderOption={(optionProps, option) => (
        <li {...optionProps} key={option.id || option.inputValue}>
          <Typography>{option.name}</Typography>
          <Typography sx={{ml: 2}}>
            {option.phone}
          </Typography>
        </li>
      )}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        if (params.inputValue !== '') {
          filtered.push({
            inputValue: params.inputValue,
            name: `${t('add')} "${params.inputValue}"`,
          });
        }

        return filtered;
      }}
      onChange={handleChange}
      TextFieldProps={{
        label: t('contactPerson'),
        required: true,
      }}
      fullWidth
      freeSolo
      selectOnFocus
      clearOnBlur
    />
  );
};

ContactPersonField.propTypes = {
  loading: Type.bool.isRequired,
  options: Type.arrayOf(
    Type.shape({
      id: Type.string,
      name: Type.string.isRequired,
    }),
  ).isRequired,
};

export default ContactPersonField;
